import React from "react";

const normalize = (v) => v || "transparent";

const SectionTransition = ({
    top,
    bottom,
    blendColor,
    height = 30,
}) => {
    const hasEnds = top || bottom;

    const topBg = normalize(top);
    const bottomBg = normalize(bottom);

    return (
        <div style={{ width: "100w", overflow: "hidden" }}>
            {/* PART 1 */}
            <div
                style={{
                    height,
                    background: hasEnds ? topBg : "transparent",
                }}
            />

            {/* PART 2 */}
            <div
                style={{
                    height,
                    position: "relative",
                }}
            >
                {hasEnds ? (
                    <>
                        {/* Bottom background */}
                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                background: bottomBg,
                            }}
                        />

                        {/* Top fading down */}
                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                background: topBg,
                                maskImage:
                                    "linear-gradient(to bottom, black, transparent)",
                                WebkitMaskImage:
                                    "linear-gradient(to bottom, black, transparent)",
                            }}
                        />
                    </>
                ) : (
                    <>
                        {/* Center-peaked blend with thick middle */}
                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                background: blendColor || "transparent",
                                maskImage: `
      linear-gradient(
        to bottom,
        transparent 0%,
        black 30%,
        black 70%,
        transparent 100%
      )
    `,
                                WebkitMaskImage: `
      linear-gradient(
        to bottom,
        transparent 0%,
        black 30%,
        black 70%,
        transparent 100%
      )
    `,
                            }}
                        />
                    </>
                )}
            </div>

            {/* PART 3 */}
            <div
                style={{
                    height,
                    background: hasEnds ? bottomBg : "transparent",
                }}
            />
        </div>
    );
};

export default SectionTransition;
